var map = {
	"./anxiety-profile.svg": 18729,
	"./anxious.svg": 65458,
	"./brain-circle.svg": 94482,
	"./brain-orange.svg": 87464,
	"./brain-red.svg": 99679,
	"./confident.svg": 75689,
	"./email-open.svg": 81750,
	"./feedback-alt.svg": 89584,
	"./feedback-hashtag.svg": 2537,
	"./feelings.svg": 90356,
	"./hiding.svg": 4478,
	"./holding phone.svg": 17224,
	"./holding-phone-half-circle.svg": 86188,
	"./joyful.svg": 85604,
	"./lesson.svg": 80911,
	"./monitoring.svg": 65457,
	"./ok.svg": 44841,
	"./peeking.svg": 9594,
	"./personalised.svg": 53128,
	"./program-learn.svg": 17864,
	"./program-vr-plan.svg": 410,
	"./questionnaire-alt.svg": 47432,
	"./questionnaire.svg": 97162,
	"./reminder.svg": 969,
	"./start.svg": 16889,
	"./therapist-session.svg": 81372,
	"./track-progress.svg": 85496,
	"./vector.svg": 59970,
	"./vret.svg": 93204,
	"./welcome.svg": 58813,
	"./winking-face.svg": 28888,
	"./your-profile.svg": 92662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74215;